import TargetLocationsField from './TargetLocationsField.component';

export default TargetLocationsField;